import type { Mission } from '../missions.ts'

export const cftc: Mission = {
  id: "cftc",
  name: "Commodity Futures Trading Commission",
  short: "CFTC",
  call: "Futures",
  kind: "independent",
  community: "financial",
  url: "https://www.cftc.gov/",
  established: 1974,
  palette: {
    primary: "#223a57",
    secondary: "#212e60",
    accent: "#870808",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Commodity_Futures_Trading_Commission_seal.svg",
  },
  motif: "chart",
  mission: {
    text: "The mission of the Commodity Futures Trading Commission is to promote the integrity, resilience, and vibrancy of the U.S. derivatives markets through sound regulation.",
    url: "https://www.cftc.gov/About/AboutTheCommission",
  },
  fact: {
    text: "Futures contracts for agricultural commodities have been traded in the United States for more than 150 years and have been under federal regulation since the 1920s.",
    url: "https://www.cftc.gov/About/AboutTheCommission",
  },
  seal: {
    file: "public/seals/cftc.svg",
    source: "https://commons.wikimedia.org/wiki/File:Commodity_Futures_Trading_Commission_seal.svg",
  },
  identifier: {
    about: "https://www.cftc.gov/About/index.htm",
    accessibility: "https://www.cftc.gov/About/EEO/AccessibilityStatement",
    foia: "https://www.cftc.gov/FOI/index.htm",
    noFear: "https://www.cftc.gov/WebPolicy/EEONoFearAct/index.htm",
    oig: "https://www.cftc.gov/OIG",
    performance: "https://www.cftc.gov/About/CFTCReports/index.htm",
    privacy: "https://www.cftc.gov/Privacy",
  },
  media: {
    photos: [
      {
        file: "/media/cftc-grain-elevators.jpg",
        small: "/media/cftc-grain-elevators-sm.jpg",
        alt: "A long row of grain elevators and steel silos beside railroad tracks under an overcast sky",
        title: "An enormous grain elevator complex in Rugby, North Dakota",
        creator: "Carol M. Highsmith",
        source: "https://www.loc.gov/item/2021757135/",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/cftc-headquarters.jpg",
        small: "/media/cftc-headquarters-sm.jpg",
        alt: "The brick entrance of the CFTC headquarters building with red awnings and the commission seal beside the door",
        title: "CFTC headquarters, Lafayette Center",
        creator: "Dclemens1971",
        source: "https://commons.wikimedia.org/wiki/File:CFTC_headquarters,_Lafayette_Center.jpg",
        license: "CC BY 4.0 (cropped)",
      },
    ],
  },
}
